/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * Enumeration of insert status types. This class will be translated to JavaScript
 * @author  Zhuoheng Huang
 */
export default class InsertStatus extends Enum{

	enumValue = null;

	static  ADD = InsertStatus.newLiteral("add");

	static  UPDATE = InsertStatus.newLiteral("update");

	static  DELETE = InsertStatus.newLiteral("delete");

	static  NOOP = InsertStatus.newLiteral("noop");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	value() {
		return this.enumValue;
	}
}


// WEBPACK FOOTER //
// ./src/generated/InsertStatus.js